import axios from 'axios';
import Swal from 'sweetalert2';
import { NotificationManager } from 'react-notifications';
import envConfig from '../config/envConfig';
import { hideLoader } from '../utils/loader';

let { baseUrl, posUrl } = envConfig;

const wayagramUrl = `${baseUrl}/wayagram-service`;
const authUrl = `${baseUrl}/auth-service`;
const smAuthUrl = `${baseUrl}/auth-sm`;
const kycUrl = `${baseUrl}/kyc-servicev2`;
const bvnUrl = `${baseUrl}/bvn-service`;
const cardUrl = `${baseUrl}/card-service`;
const contactUrl = `${baseUrl}/contact-service`;
const billPaymentUrl = `${baseUrl}/billspayment-service`;
const billPaymentUrl2 = `${baseUrl}/billspayment-servicev2`;
const walletUrl = `${baseUrl}/temporal-service`;
const smWalletUrl = `${baseUrl}/temporal-sm-service`;
const paymentRequestUrl = `${baseUrl}/payment-request`;
const accountCreationUrl = `${baseUrl}/account-service`;
const roleUrl = `${baseUrl}/role-service`;
const withdrawalUrl = `${baseUrl}/withdrawal-service`;
const ussdUrl = `${baseUrl}/ussd-service`;
const disputeUrl = `${baseUrl}/social-dispute`;
const socketUrl = `${baseUrl}/chats-service`;
const logUrl = `${baseUrl}/logs-service`;
const wayapayDispute = `${baseUrl}/complaint-service`;
const contentManagementUrl = `${baseUrl}/content-management-service`;
const notificationUrl = `${baseUrl}/notification-service`;
const notificationAggUrl = `${baseUrl}/notification-aggregate`;
const fileResourseUrl = `${baseUrl}/file-resource-service`;
const ussdTopUp = `${baseUrl}/ussd-middle-ware`;
const settlementUrl = `${baseUrl}/settlement-service`;
const commissionUrl = `${baseUrl}/commission-service`;
const qrCodeUrl = `${baseUrl}/qrcode-service`;
const referralUrl = `${baseUrl}/referral-service`;
const walletV2 = `${baseUrl}/wallet-v2`;
const nipBvnUrl = `${baseUrl}/nip-bvn-service`;
const fraudUrl = `${baseUrl}/fraud-service`
const statementUrl = `${baseUrl}/statement-service`
const loanUrl = `${baseUrl}/loan-service`
const terminalUrl = `${posUrl}/terminal-service`


export const customBaseUrl = {
  terminalUrl,
  statementUrl,
  wayagramUrl,
  authUrl,
  kycUrl,
  bvnUrl,
  cardUrl,
  contactUrl,
  billPaymentUrl,
  billPaymentUrl2,
  ussdUrl,
  walletUrl,
  smWalletUrl,
  paymentRequestUrl,
  accountCreationUrl,
  roleUrl,
  withdrawalUrl,
  disputeUrl,
  socketUrl,
  logUrl,
  wayapayDispute,
  contentManagementUrl,
  notificationUrl,
  notificationAggUrl,
  fileResourseUrl,
  ussdTopUp,
  settlementUrl,
  commissionUrl,
  qrCodeUrl,
  referralUrl,
  walletV2,
  nipBvnUrl,
  fraudUrl,
  smAuthUrl,
  loanUrl,
};
const CLIENT_TYPE = 'ADMIN';
const CLIENT_ID = 'WAYABANK';

export const httpPost = async (url, postBody, isNotAuth) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  try {
    const res = await axios.post(
      `${url}`,
      postBody,
      !isNotAuth
        ? {
            headers: {
              Authorization: `${localStorage.token}`,
              'content-type': 'application/json',
              'CLIENT-TYPE': CLIENT_TYPE,
              'CLIENT-ID': CLIENT_ID,
            },
          }
        : {
          headers: {
            'content-type': 'application/json',
            'CLIENT-TYPE': CLIENT_TYPE,
            'CLIENT-ID': CLIENT_ID,
          },
        }
    );
    return res.data;
  } catch (error) {
    hideLoader();
    if (error?.response?.data.error === 'Internal Server Error') {
      return {
        status: false,
        message: error.response.data.message ?? error.response.data.error,
      };
    }
    if (error?.response?.data.message === 'Validation Errors') {
      Object.values(error.response.data.data).map((item) =>
        NotificationManager.error(item, 'Oops!', 5000)
      );
      return error.response?.data;
    }
    return error.response?.data;
  }
};

export const httpPostUnreloaded = async (
  url,
  postBody,
  otherUrl,
  isNotAuth
) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  try {
    const res = await axios.post(
      `${url}`,
      postBody,
      !isNotAuth
        ? {
            headers: {
              Authorization: `${localStorage.token}`,
              'Content-Type': 'application/x-www-form-urlencoded',
              'CLIENT-TYPE': CLIENT_TYPE,
              'CLIENT-ID': CLIENT_ID,
            },
          }
        : {}
    );
    // console.log(res);
    return res.data;
  } catch (error) {
    hideLoader();
    return error.response?.data;
  }
};

export const httpPostFormData = async (url, postBody, otherUrl, isNotAuth) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  try {
    const res = await axios.post(
      `${url}`,
      postBody,
      !isNotAuth
        ? {
            headers: {
              Authorization: `${localStorage.token}`,
              'Content-Type': 'multipart/form-data',
              'CLIENT-TYPE': CLIENT_TYPE,
              'CLIENT-ID': CLIENT_ID,
            },
          }
        : {}
    );
    // console.log(res);
    return res.data;
  } catch (error) {
    hideLoader();
    return error.response?.data;
  }
};

export const httpGet = async (url, otherUrl, isNotAuth, isNotHeader) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  try {
    const res = await axios.get(
      url,
      !isNotAuth
        ? {
            headers: {
              Authorization: `${localStorage.token}`,
              'CLIENT-TYPE': CLIENT_TYPE,
              'CLIENT-ID': CLIENT_ID,
            },
          }
        :!isNotHeader 
        ? {
          headers: {
            'CLIENT-TYPE': CLIENT_TYPE,
            'CLIENT-ID': CLIENT_ID,
          },
        }
        : {}
    );
    // console.log(res);
    return res.data;
  } catch (error) {
    hideLoader();
    if (error?.response?.data?.message === 'Validation Errors') {
      Object.values(error?.response?.data?.data).map((item) =>
        Swal.fire('Oops!', item, 'error')
      );
      return error?.response?.data;;
    }
    return error?.response?.data;
  }
};

export const httpGetPdf = async (url, otherUrl, isNotAuth) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  try {
    const res = await axios.get(
      url,
      !isNotAuth
        ? {
          responseType: "blob",
            headers: {
              Authorization: `${localStorage.token}`,
              'Content-Type': 'application/pdf',
              'CLIENT-TYPE': CLIENT_TYPE,
              'CLIENT-ID': CLIENT_ID,
            },
          }
        : {}
    );
    // console.log(res);
    return res.data;
  } catch (error) {
    hideLoader();
    if (error?.response?.data?.message === 'Validation Errors') {
      Object.values(error?.response?.data?.data).map((item) =>
        Swal.fire('Oops!', item, 'error')
      );
      return error?.response?.data;;
    }
    return error?.response?.data;
  }
};

export const httpPut = async (url, postBody, otherUrl, isNotAuth) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  try {
    const res = await axios.put(
      `${url}`,
      postBody,
      !isNotAuth
        ? {
            headers: {
              Authorization: `${localStorage.token}`,
              'CLIENT-TYPE': CLIENT_TYPE,
              'CLIENT-ID': CLIENT_ID,
            },
          }
        : {}
    );
    // console.log(res);
    return res.data;
  } catch (error) {
    hideLoader();
    if (error.response.data.message === 'Validation Errors') {
      return {
        status: false,
        message: error.response?.data.data[0],
      };
    }
    return error.response?.data;
  }
};

export const httpPatch = async (url, postBody, otherUrl, isNotAuth) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  try {
    const res = await axios.patch(
      `${url}`,
      postBody,
      !isNotAuth
        ? {
            headers: {
              Authorization: `${localStorage.token}`,
              'CLIENT-TYPE': CLIENT_TYPE,
              'CLIENT-ID': CLIENT_ID,
            },
          }
        : {}
    );
    return res.data;
  } catch (error) {
    return error.response?.data;
  }
};

export const httpDelete = async (url, data, otherUrl, isNotAuth) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      'Please check your internet',
      'Oops!',
      3000
    );
  }
  try {
    const res = await axios.delete(
      `${url}`,
      !isNotAuth
        ? {
            headers: {
              Authorization: `${localStorage.token}`,
              'CLIENT-TYPE': CLIENT_TYPE,
              'CLIENT-ID': CLIENT_ID,
            },
            data,
          }
        : {}
    );
    // console.log(res);
    return res.data;
  } catch (error) {
    hideLoader();
    return error.response?.data;
  }
};
